module.exports = __webpack_public_path__ + "img/danelec-square-original.06c2b688.svg";